<template>
  <!-- swiper-container, swiper-wrapper, swiper-... are from swiper-bundle.css-->
  <div class="swiper-container" v-swiper>
    <div class="swiper-wrapper">
      <slot></slot>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper, { Pagination, Autoplay } from 'swiper';

Swiper.use([Pagination, Autoplay]);

export default {
  props: {
    slidesPerView: {
      type: Number,
    },
    spaceBetween: {
      type: Number,
      default: 10,
    },
    breakpoints: {
      type: Object,
    },
    hidePagination: Boolean,
  },
  directives: {
    swiper: {
      inserted(el, _, { context }) {
        const config = {
          direction: 'horizontal',
          observer: true,
          observeParents: true,
          autoplay: {
            delay: 10000,
          },
          watchOverflow: true,
          slidesPerView: context.slidesPerView,
          spaceBetween: context.spaceBetween,
        };
        if (!context.hidePagination) {
          config.pagination = {
            el: '.swiper-pagination',
            clickable: true,
          };
        }
        // 1 slide does not need to apply breakpoints
        if (context.slidesPerView !== 1) {
          if (context.breakpoints) {
            config.breakpoints = context.breakpoints;
          } else {
            // default breakpoints
            config.breakpoints = {
              320: {
                slidesPerView: 2.2,
                spaceBetween: 10,
              },
              1600: {
                slidesPerView: 4.2,
              },
            };
          }
        }
        context.swiper = new Swiper(el, config);
        context.swiper.on('slideChange', () => {
          context.$emit('slideChange', context.swiper);
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~swiper/swiper-bundle.css";

.swiper-slide {
  width: 100%;
}

.swiper-pagination {
  bottom: 0;
}
</style>
